<article class="homepage-social-links">
	<ng-container [ngSwitch]="socialMediaLink?.socialMediaType">
		<ng-template [ngSwitchCase]="socialMediaType?.Facebook" class="social-media-link">
			<a target="_blank" [href]="url">
				<span *ngIf="isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/facebook-circle.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Visit us on Facebook">
				</span>
				<span *ngIf="!isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/facebook.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Visit us on Facebook">
				</span>
			</a>
		</ng-template>
		<ng-template [ngSwitchCase]="socialMediaType?.Instagram">
			<a target="_blank" [href]="url">
				<span *ngIf="isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/instagram-circle.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Visit us on Instagram">
				</span>
				<span *ngIf="!isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/instagram.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Visit us on Instagram">
				</span>
			</a>
		</ng-template>
		<ng-template [ngSwitchCase]="socialMediaType?.Twitter">
			<a target="_blank" [href]="url">
				<span *ngIf="isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/twitter-circle.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Visit us on Twitter">
				</span>
				<span *ngIf="!isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/twitter.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Visit us on Twitter">
				</span>
			</a>
		</ng-template>
		<ng-template [ngSwitchCase]="socialMediaType?.Email">
			<a [href]="'mailto:'+ url">
				<span>
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/mail_v2.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Email Us">
				</span>
				<span *ngIf="!isRound">
					<img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/mail_v2.png"
						class="social-media-logo px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Email Us">
				</span>
			</a>
		</ng-template>
	</ng-container>
</article>
